import { ref, watchEffect } from 'vue'
import { useComplementQuery } from '@server/graphql/queries/complementsQuery'
import { INodeData } from '@/types/index'

/**
 * Função para buscar os dados de complementação com base no ID fornecido.
 * Utiliza watchEffect para monitorar a consulta e atualizar os dados reativamente.
 *
 * @param id - O ID do node a ser buscado.
 * @returns Um objeto com referências reativas para os dados de complementação, estado de carregamento, erros e função de parada.
 */
const fetchComplement = (id: string) => {
  const data = ref<INodeData | null>(null)
  const loading = ref(false)
  const error = ref<Error | null>(null)
  let query: ReturnType<typeof useComplementQuery> | null = null

  const stop = watchEffect(() => {
    if (query) {
      query.stop()
    }

    query = useComplementQuery({ id })
    loading.value = true
    error.value = null

    watchEffect(() => {
      if (query?.result.value) {
        data.value = query.result.value.findNodeNavigation.payload.nodeNavigation
        loading.value = false
      }

      if (query?.error.value) {
        error.value = query.error.value
        loading.value = false
      }
    })
  })

  return { data, loading, error, stop }
}

export default fetchComplement
